import { config } from '../config';
import { getIdToken } from './auth';

export interface Customer { id: string; name: string; phones: string[]; emails: string[]; company?: string; createdAt: string; issues?: Issue[]; interactions?: Interaction[] }
export interface Issue { id: string; customerId: string; title: string; category: string; priority: 'low' | 'normal' | 'high'; summary: string; status: 'open' | 'pending' | 'closed'; createdAt: string; updatedAt: string }
export interface Interaction { SK: string; type: 'inbound-call' | 'outbound-call' | 'email'; contactId?: string; agent?: string; agentArn?: string; durationSec?: number; subject?: string; to?: string; createdAt: string; endedAt?: string }
export interface FollowUp { PK: string; SK: string; issueId: string; channel: 'call' | 'email'; dueAt: string; status: string; assignee?: string }

async function call<T>(method: string, path: string, body?: unknown): Promise<T> {
  const token = await getIdToken();
  const res = await fetch(`${config.apiUrl}${path}`, {
    method,
    headers: { authorization: `Bearer ${token}`, 'content-type': 'application/json' },
    body: body ? JSON.stringify(body) : undefined,
  });
  if (!res.ok) throw new Error(`${method} ${path}: ${res.status} ${await res.text()}`);
  return res.json() as Promise<T>;
}

export const api = {
  findByPhone: (phone: string) => call<Customer[]>('GET', `/customers?phone=${encodeURIComponent(phone)}`),
  listCustomers: () => call<Customer[]>('GET', '/customers'),
  getCustomer: (id: string) => call<Customer>('GET', `/customers/${id}`),
  createCustomer: (c: Pick<Customer, 'name' | 'phones' | 'emails' | 'company'>) => call<Customer>('POST', '/customers', c),
  createIssue: (customerId: string, i: Partial<Issue>) => call<Issue>('POST', `/customers/${customerId}/issues`, i),
  updateIssue: (customerId: string, issueId: string, i: Partial<Issue>) => call<Issue>('PATCH', `/customers/${customerId}/issues/${issueId}`, i),
  addNote: (issueId: string, body: string) => call<unknown>('POST', `/issues/${issueId}/notes`, { body }),
  listNotes: (issueId: string) => call<{ body: string; author: string; createdAt: string }[]>('GET', `/issues/${issueId}/notes`),
  addFollowUp: (issueId: string, f: Pick<FollowUp, 'channel' | 'dueAt' | 'assignee'>) => call<FollowUp>('POST', `/issues/${issueId}/followups`, f),
  listFollowUps: () => call<FollowUp[]>('GET', '/followups'),
  sendEmail: (customerId: string, e: { to: string; subject: string; body: string; issueId?: string }) => call<Interaction>('POST', `/customers/${customerId}/email`, e),
};
